/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useState, useMemo, useEffect } from 'react'
import { Modal, Select, Radio, Tabs, Input, Icon } from 'antd'
// import { Icon } from '@ant-design/compatible'
// import alasql from 'alasql'
// import moment from 'moment'

import { useListOperations } from '../list-utils'
import { Draggable } from 'react-beautiful-dnd'

import { OrderedDragAndDropList } from 'core/component'
import { Filler } from 'core/screen-util'

// import { dataOperations } from './filter-utils'
import GridFilter from 'grid-filter/GridFilter'
import { dateCol, numCol, strCol } from '@integec/grid-tools/lib/cols'
import { AND_PASS } from '../grid-filter/GridFilter'

const { Option } = Select
const { TabPane } = Tabs
const { TextArea } = Input

// alasql.fn.DATE = function(dateStr) {
//   var date = moment(dateStr)
//   return date.valueOf()
// }

const SortOrderSelectRow = ({
  index,
  data = {},
  updateByIndex,
  removeByIndex,
}) => {
  return (
    <Draggable draggableId={`index-${index}`} index={index}>
      {provided => (
        <div
          css={{
            display: 'flex',
            alignItems: 'center',
            padding: '5px 0px',
            borderBottom: 'solid 1px lightgrey',
            zIndex: '60000',
          }}
          ref={provided.innerRef}
          {...provided.draggableProps}
        >
          <div {...provided.dragHandleProps}>
            <Icon css={{ fontSize: 25 }} type="menu" />
          </div>
          <div
            css={{
              fontSize: 15,
              fontWeight: 'bold',
              width: 250,
              marginLeft: 20,
            }}
          >
            {data.display || data.id}
          </div>
          <Filler />
          <div>
            <Radio.Group
              value={data.order || 'ASC'}
              onChange={e => {
                updateByIndex({
                  index,
                  data: { ...data, order: e.target.value },
                })
              }}
            >
              <Radio value="ASC">Asc</Radio>
              <Radio value="DESC">Desc</Radio>
            </Radio.Group>
          </div>
          <div css={{ marginLeft: 20, marginRight: 10 }}>
            <Icon
              css={{ fontSize: 25 }}
              type="minus-circle"
              onClick={() => removeByIndex(index)}
            />
          </div>
        </div>
      )}
    </Draggable>
  )
}

const getGridHeaders = columnHeaders => {
  return columnHeaders.map(col => {
    const { id, display, dataType } = col
    if (dataType === 'STRING') return strCol({ ident: id, display })
    if (dataType === 'NUMBER') return numCol({ ident: id, display })
    // if (dataType === 'DATESTR')
    //   return dateCol({ ident: id, display, dataFormat: 'MM/DD/YYYY' })
    if (dataType === 'DATE')
      return dateCol({
        ident: id,
        display,
        dataFormat: 'MM/DD/YYYY',
        displayFormat: 'MM/DD/YYYY',
      })
  })
}

const FilterSortModal = ({
  columnHeaders,
  hide,
  profile,
  // sortOrderArray,
  setProfile,
  setFilterCondition,
  filterCondition,
  andOrPass,
  setAndOrPass,
}) => {
  const [sortItems, listActions] = useListOperations(profile.sortItems || [])

  const [selectedCol, setSelectedCol] = useState(columnHeaders[0])

  const [notes, setNotes] = useState(profile.notes || '')
  const gridColumns = useMemo(_ => getGridHeaders(columnHeaders), [
    columnHeaders,
  ])

  useEffect(
    _ => {
      let sortItems = []
      try {
        sortItems = JSON.parse(profile.sortText)
      } catch (error) {
        sortItems = []
      }
      listActions.replace(sortItems)
    },
    [listActions, profile.sortText]
  )

  useEffect(
    _ => {
      let filterCondition = []
      try {
        filterCondition = JSON.parse(profile.filterText)
      } catch (error) {
        filterCondition = [{}]
      }
      setFilterCondition(filterCondition)
    },
    [profile.filterText, setFilterCondition]
  )

  const onOk = () => {
    try {
      setProfile({
        ...profile,
        notes,
        filterText: JSON.stringify(filterCondition),
        sortText: JSON.stringify(sortItems),
        sortItems,
        filterCondition: filterCondition.map(f => ({ ...f, andOrPass })),
        andOrPass: andOrPass || filterCondition[0].andOrPass || AND_PASS,
      })
      hide()
    } catch (e) {
      console.log({ e })
      // setFilterTextError('Syntax Error in Query String')
    }
  }

  const sortOrderItemRender = props => {
    return <SortOrderSelectRow {...props} />
  }

  return (
    <Modal
      title="Filter / Sort"
      width="55vw"
      visible
      onOk={onOk}
      okText="Ok"
      onCancel={hide}
      bodyStyle={{
        height: '500px',
      }}
      centered
      maskClosable={false}
    >
      <Tabs defaultActiveKey="filter" animated={false} type="card">
        <TabPane key="filter" tab="Filter">
          <GridFilter
            header={gridColumns}
            data={[]}
            filterCondition={filterCondition}
            setFilterCondition={setFilterCondition}
            andOrPass={andOrPass}
            setAndOrPass={setAndOrPass}
            MAX_CONDITION={15}
            MAX_HEIGHT="300px"
          />
        </TabPane>
        <TabPane key="sort" tab="Sort">
          <div>
            <b>Select Column : </b>
            <Select
              showSearch
              value={selectedCol && selectedCol.id}
              onChange={val => {
                const col = columnHeaders.find(c => c.id === val)
                setSelectedCol(col)
                col &&
                  listActions.addNew({
                    ...col,
                    order: 'ASC',
                  })
              }}
              css={{ width: 250 }}
            >
              {columnHeaders.map(col => (
                <Option key={col.id} value={col.id} title={col.display}>
                  {col.display}
                </Option>
              ))}
            </Select>
          </div>
          <div css={{ paddingTop: 10 }}>
            <OrderedDragAndDropList
              items={sortItems}
              listActions={listActions}
              style={{ overflowY: 'scroll', height: '350px' }}
              itemRender={sortOrderItemRender}
            />
          </div>
        </TabPane>
        <TabPane key="notes" tab="Notes">
          <TextArea
            value={notes}
            onChange={e => setNotes(e.target.value)}
            rows={18}
            css={{ resize: 'none', height: '350px' }}
          />
        </TabPane>
      </Tabs>
    </Modal>
  )
}

export default FilterSortModal
